import { render } from "./NumberOfPagers.vue?vue&type=template&id=79f6094c"
import script from "./NumberOfPagers.vue?vue&type=script&lang=js"
export * from "./NumberOfPagers.vue?vue&type=script&lang=js"
script.render = render

export default script